/**
 * A building's Plan tab: the stacking plan of its floors, its vertical columns
 * drawn in a lane beside the lots (spec 2026-10-25-21). The detailed riser
 * diagram (spec 2026-10-19-03 §2) stays one link away — the lane's « Vue en
 * coupe » sets `?view=columns` — but is no longer a second mode competing
 * with the plan: the « Niveaux / Colonnes » toggle and the « Synoptique des
 * colonnes » button both opened it.
 */
import { useTranslation } from 'react-i18next'
import { Link, useSearch } from '@tanstack/react-router'
import { mdiArrowLeft } from '@mdi/js'
import { AppIcon } from '../ui/icon'
import { StackingPlan } from '../StackingPlan'
import { RiserDiagram } from './RiserDiagram'

export function BuildingPlanTab({ org, buildingUid }: { org: string; buildingUid: string }) {
    const { t } = useTranslation('assets')
    const search = useSearch({ strict: false }) as { view?: string }
    if (search.view !== 'columns') return <StackingPlan org={org} buildingUid={buildingUid} />
    return (
        <div className="flex flex-col gap-3">
            <Link
                to="."
                search={(prev: Record<string, unknown>) => ({ ...prev, view: undefined })}
                replace
                className="inline-flex w-fit items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
                data-testid="building-plan-back-to-floors"
            >
                <AppIcon path={mdiArrowLeft} size="sm" />
                {t('riserDiagram.back_to_plan')}
            </Link>
            <RiserDiagram org={org} buildingUid={buildingUid} />
        </div>
    )
}
